import React, { Component } from "react";
import { Loader, utils, field } from "@mc/mc-legacy";
import { connect } from "react-redux";
import * as pracovniciActions from "../../actions/pracovniciActions";
import PropTypes from "prop-types";
import * as appUtils from "../../utils/appUtils";

/**
 * field pro filtr čipování Ma
 */
class QsignPracovnikField extends Component {
  static propTypes = {
    empty: PropTypes.bool,
  };
  static defaultProps = {
    empty: true,
  };

  componentDidMount() {
    this.fetchData(true);
  }

  UNSAFE_componentWillReceiveProps() {
    this.fetchData();
  }

  fetchData = (force = false) => {
    this.props.dispatch(pracovniciActions.fetchPracovniciIfNeeded(force));
  };

  render() {
    const { dispatch, store, empty, ...componentProps } = this.props;

    if (store.fetching) {
      return <Loader />;
    }

    return (
          <field.Autocomplete
              {...componentProps}
              getItemName={(item) => (item ? appUtils.getPracovnikOrganizacniJednotkaLabel(item) : "")}
              items={store.rows.sort((a, b) => a.loginName.localeCompare(b.uplneJmeno))}
              onChange={(item) => {
                  dispatch(pracovniciActions.setPracovnikToFilter(item));
              }}
              placeholder={'Zafiltrovat pracovníka'}
          />
    );
  }
}

export default connect((state) => {
    return {
        store: utils.storeFromArea(state, pracovniciActions.QSIGN_PRACOVNICI),
    };
})(QsignPracovnikField);
